// 一键匹配
const searchFieldsOnekey = {
  长期意向: {
    label: '长期意向',
    width: '25%',
    type: 'multSelect',
    options: {
      Y: 'Y.积极看机会',
      N: 'N.暂时不看机会',
      F: 'F.再跟进',
      空: '空',
    },
  },
  职能模块: {
    label: '职能模块',
    width: '25%',
    type: 'multSelect',
    options: [],
  },
  细分职能: {
    label: '细分职能',
    width: '25%',
    type: 'createSelect',
    option: [],
  },
  擅长方向: {
    label: '擅长方向',
    width: '25%',
    type: 'multSelect',
    option: [],
  },
  职级: {
    label: '职级',
    width: '25%',
    type: 'createSelect',
    options: {
      '1': '1.高管',
      '2': '2.部门总',
      '3': '3.部门副总/总助/团队长',
      '4': '4.部门核心骨干',
      '5': '5.新人三年以下',
      空: '空',
    },
  },
  业绩: {
    label: '业绩',
    width: '25%',
    type: 'multSelect',
    options: {
      aaa: 'aaa.领军人物',
      aa: 'aa.卓越人选',
      a: 'a.优秀人选',
      b: 'b.良好',
      c: 'c.一般',
      d: 'd.较差',
      空: '空',
    },
  },
  地域: {
    label: '地域',
    width: '25%',
    type: 'createSelect',
    options: [
      '北京',
      '上海',
      '广州',
      '深圳',
      '香港',
      '成都',
      '杭州',
      '重庆',
      '武汉',
      '苏州',
      '西安',
      '天津',
      '南京',
      '郑州',
      '长沙',
      '沈阳',
      '青岛',
      '宁波',
      '东莞',
      '无锡',
      '昆明',
      '大连',
      '厦门',
      '合肥',
      '佛山',
      '福州',
      '哈尔滨',
      '济南',
      '温州',
      '长春',
      '石家庄',
      '空',
    ],
  },
  人员背景: {
    label: '人员背景',
    width: '25%',
    options: [
      {
        value: '通用',
        label: '通用',
        children: [
          { value: '四大背景', label: '四大背景' },
          { value: '产业背景', label: '产业背景' },
          { value: '政府背景', label: '政府背景' },
          { value: '监管背景', label: '监管背景' },
          { value: '咨询背景', label: '咨询背景' },
          { value: '内资背景', label: '内资背景' },
          { value: '外资背景', label: '外资背景' },
          { value: '银行背景', label: '银行背景' },
          { value: '券商背景', label: '券商背景' },
          { value: '公募背景', label: '公募背景' },
        ],
      },
      {
        value: '投行',
        label: '投行',
        children: [
          { value: 'VIP', label: 'VIP' },
          { value: '在大平台做过', label: '在大平台做过' },
          { value: '在合资外资做过', label: '在合资外资做过' },
        ],
      },
      {
        value: '投行港股',
        label: '投行港股',
        children: [{ value: '中资行', label: '中资行' }, { value: '外资行', label: '外资行' }],
      },
      {
        value: '股权投资',
        label: '股权投资',
        children: [
          { value: '投行背景', label: '投行背景' },
          { value: 'FA背景', label: 'FA背景' },
          { value: '学科背景', label: '学科背景' },
        ],
      },
      {
        value: '二级资管',
        label: '二级资管',
        children: [
          { value: '公募公募', label: '公募公募' },
          { value: '公募专户', label: '公募专户' },
          { value: '券商自营', label: '券商自营' },
          { value: '券商资管', label: '券商资管' },
          { value: '保险和保险资管', label: '保险和保险资管' },
          { value: '银行理财子', label: '银行理财子' },
          { value: '私募', label: '私募' },
          { value: '第三方平台', label: '第三方平台' },
          { value: '海外平台', label: '海外平台' },
          { value: '信托', label: '信托' },
          { value: '财富公司', label: '财富公司' },
        ],
      },
      {
        value: '中后台',
        label: '中后台',
        children: [
          { value: 'PE股权', label: 'PE股权' },
          { value: '海外', label: '海外' },
          { value: '咨询', label: '咨询' },
          { value: 'IT系统公司', label: 'IT系统公司' },
          { value: '第三方验证机构', label: '第三方验证机构' },
          { value: '评级机构', label: '评级机构' },
          { value: '海外评级机构', label: '海外评级机构' },
          { value: '托管', label: '托管' },
          { value: '律所', label: '律所' },
          { value: '前台业务背景', label: '前台业务背景' },
          { value: '审计', label: '审计' },
          { value: '会计师事务所', label: '会计师事务所' },
        ],
      },
      {
        value: '品牌公关',
        label: '品牌公关',
        children: [
          { value: '媒体记者出身', label: '媒体记者出身' },
          { value: '4A广告公司', label: '4A广告公司' },
          { value: '互联网', label: '互联网' },
          { value: '科技', label: '科技' },
          { value: '金融(公募基金）', label: '金融(公募基金）' },
          { value: '金融(私募基金）', label: '金融(私募基金）' },
          { value: '金融（券商）', label: '金融（券商）' },
        ],
      },
      {
        value: 'HR人力',
        label: 'HR人力',
        children: [
          { value: 'PEVC背景', label: 'PEVC背景' },
          { value: '猎头背景', label: '猎头背景' },
          { value: '互联网背景', label: '互联网背景' },
          { value: '分支机构背景', label: '分支机构背景' },
          { value: '医药医疗背景', label: '医药医疗背景' },
          { value: '筹备期经验（从0到1）', label: '筹备期经验（从0到1）' },
          { value: '老板心腹', label: '老板心腹' },
        ],
      },
    ],
  },
  公司: {
    label: '公司',
    width: '25%',
  },
  年龄: {
    label: '年龄',
    width: '25%',
    type: 'range',
  },
  平台: {
    label: '平台',
    width: '25%',
    type: 'multSelect',
    options: {
      A: 'A.大平台',
      B: 'B.中平台',
      C: 'C.小平台',
      '': '空',
    },
  },
  学历: {
    label: '学历',
    width: '25%',
    type: 'multSelect',
    options: ['中专', '大专', '本科', '硕士', '博士', '博士后', '空'],
  },
  学历标签: {
    label: '学历标签',
    width: '25%',
    type: 'multSelect',
    options: [
      '常青藤',
      '清北交复',
      '985',
      '211',
      '海外背景',
      'QS100',
      'TIMES100',
      '理工科',
      '财务',
      '法务',
      '金融',
      '医药医疗',
      '微电子',
      '计算机',
      '中金line',
      '中信line',
      '建投line',
      '广发学历',
      '前海开源line',
    ],
  },
  行业: {
    label: '行业',
    width: '25%',
    type: 'createSelect',
    options: [],
  },
  毕业院校: {
    label: '毕业院校',
    width: '25%',
  },
  部门: {
    label: '部门',
    width: '25%',
  },
  目前职位: {
    label: '目前职位',
    width: '25%',
  },
  专业职级: {
    label: '专业职级',
    width: '25%',
    type: 'createSelect',
    options: ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN', '空'],
  },
  期望职能: {
    label: '期望职能',
    prop: '期望职能',
    type: 'multSelect',
    width: '25%',
    options: ['KC-内核', 'QC-质控', 'ECM', 'PEVC-股权投资', 'CFO-财务总监', 'IS-董秘'],
  },
  期望行业: {
    label: '期望行业',
    width: '25%',
    type: 'createSelect',
    options: [],
  },
  期望地域: {
    label: '期望地域',
    width: '25%',
    type: 'createSelect',
    options: [
      '北京',
      '上海',
      '广州',
      '深圳',
      '香港',
      '成都',
      '杭州',
      '重庆',
      '武汉',
      '苏州',
      '西安',
      '天津',
      '南京',
      '郑州',
      '长沙',
      '沈阳',
      '青岛',
      '宁波',
      '东莞',
      '无锡',
      '昆明',
      '大连',
      '厦门',
      '合肥',
      '佛山',
      '福州',
      '哈尔滨',
      '济南',
      '温州',
      '长春',
      '石家庄',
      '空',
    ],
  },
  职业资格: {
    label: '职业资格',
    width: '25%',
    type: 'multSelect',
    options: [
      '保代',
      '准保',
      '保代A类',
      '保代B类',
      '保代C类',
      '基金从业资格',
      '证券从业资格',
      'CFA',
      'CPA',
      'FRM',
      '律师执业资格',
      '法律从业资格',
      'REITs基金经理从业资格',
      '期货从业资格',
      '银行从业资格',
      'CIA（审计师）',
      'ACCA（国际注册会计师）',
      'CMA（美国注册管理会计师）',
      'CISA（信息系统审计师）',
      'CTA（税务师）',
      'SOA（北美保险精算师）',
      'CAA（保险精算师）',
    ],
  },
  个性标签: {
    label: '个性标签',
    width: '25%',
  },
  语言标签: {
    label: '语言标签',
    width: '25%',
    type: 'multSelect',
    options: ['英文-1-母语水平', '英文-2-工作语言', '英文-3-可顺利读写，口语较弱', '粤语', '日语', '法语', '小语种'],
  },
  籍贯: {
    label: '籍贯',
    width: '25%',
  },
  管理职级: {
    label: '管理职级',
    width: '25%',
    type: 'createSelect',
    options: [
      '公司总经理',
      '公司副总',
      '公司总助',
      '一级部门总',
      '二级部门总',
      '部门副总',
      '部门总助',
      '总监',
      '副总监',
      '经理',
      '主管',
      '专员',
    ],
  },
  姓名: {
    label: '姓名',
    width: '25%',
  },
  性别: {
    label: '性别',
    width: '25%',
    type: 'multSelect',
    options: ['男', '女', '空'],
  },
  手机: {
    label: '手机',
    width: '25%',
  },
  邮箱: {
    label: '邮箱',
    width: '25%',
  },
  座机: {
    label: '座机',
    width: '25%',
  },
  婚育: {
    label: '婚育',
    width: '25%',
    type: 'multSelect',
    options: ['未婚', '已婚未育', '已婚已育', '其他', '空'],
  },
  香港牌照: {
    label: '香港牌照',
    width: '25%',
    type: 'multSelect',
    options: [
      '证券交易',
      '期货合约交易',
      '杠杆式外汇交易',
      '就证券提供意见',
      '就期货合约提供意见',
      '就机构融资提供意见',
      '提供自动化交易服务',
      '提供证券保证金融资',
      '提供资产管理',
      '提供信贷评级服务',
    ],
  },
  投资风格: {
    label: '投资风格',
    type: 'multSelect',
    options: ['GARP型', '价值型', '成长型', '极致成长型', '综合型'],
    width: '25%',
  },
  个人风格: {
    label: '个人风格',
    width: '25%',
    type: 'multSelect',
    options: [
      '保守',
      '稳健',
      '开拓（追求卓越）',
      '激进（狼性文化）',
      'social型',
      '学术研究型',
      '适合美元',
      '适合人民币',
      '具有创业精神',
      '情商高',
      '校友资源型',
      '政府资源型',
      '容貌风格',
    ],
  },
}
const cateFieldOnekey = {
  '承揽-承做': {
    label: '承揽-承做',
    prop: '承揽-承做',
    type: 'multSelect',
    width: '25%',
    options: ['承揽', '承做', '存续期管理'],
  },
  意向平台: {
    label: '意向平台',
    width: '25%',

    type: 'multSelect',
    options: ['国企', '民企', '合资外资', '大平台', '中大型平台', '市场化激励平台'],
  },
  公开业绩: {
    label: '公开业绩',
    width: '25%',
    type: 'multSelect',
    options: ['有', '无'],
  },
  投资标的: {
    label: '投资标的',
    width: '25%',
    type: 'multSelect',
    options: ['公募FOF', '私募FOF'],
  },
  转换诉求: {
    label: '转换诉求',
    width: '25%',
    type: 'multSelect',
    options: ['一级', '卖方', '买方-公募', '买方-保险', '买方-私募', '买方-券商资管', '上市公司董秘'],
  },
  REITs任职情况: {
    label: 'REITs任职情况',
    width: '25%',
    labelWidth: '100px',
    type: 'multSelect',
    options: ['在任', '拟任', '未定'],
  },
  医疗科室: {
    label: '医疗科室',
    prop: '医疗科室',
    type: 'multSelect',
    width: '25%',
    options: [
      '外科',
      '神经外科',
      '脑科学',
      '骨科',
      'ICU',
      '血管外科',
      '心内科',
      '心外科',
      '呼吸科',
      '消化科',
      '内分泌科',
      '急诊科',
      '齿科',
      '眼科',
      '康复科',
      '肾内科',
      '耳鼻喉科',
      '生殖妇产',
      '设备科',
      '影像科',
      '超声科',
      '放射科',
      '信息科',
      '妇产科',
      '肿瘤科',
      '检验科',
      '血液科',
      'LDT三方检验所',
      '药企',
      '高校',
    ],
  },
  业务方向: {
    label: '业务方向',
    prop: '业务方向',
    type: 'multSelect',
    width: '25%',
    options: ['化工', '精细化工', '医药', '石油&天然气', '冶金/矿业', '新能源'],
  },
  上市经验: {
    label: '上市经验',
    prop: '上市经验',
    type: 'multSelect',
    width: '25%',
    options: ['主板上市', '科创板上市', '香港上市', '创业板上市', '新三板上市', '美国上市', '无'],
  },
  业务类型: {
    label: '业务类型',
    prop: '业务类型',
    type: 'multSelect',
    width: '25%',
    options: ['生产业务', '项目业务', '人民币基金', '销售和市场业务', '研发业务', '美元基金'],
  },
  是否量产: {
    label: '是否量产',
    width: '25%',
    type: 'select',
    options: ['是', '否'],
  },
  是否流片: {
    label: '是否流片',
    width: '25%',
    type: 'select',
    options: ['是', '否'],
  },
  投资年限: {
    label: '投资年限',
    width: '25%',
    type: 'multSelect',
    options: ['1-3年', '3-7年', '7-10年', '10年以上'],
  },
  规模: {
    label: '规模',
    width: '25%',
    type: 'multSelect',
    options: ['20亿以下', '20-50亿', '50-100亿', '100亿以上'],
  },
  平台性质: {
    label: '平台性质',
    width: '25%',
    type: 'multSelect',
    options: ['美元/双币种', '人民币', '国家队', '险资', '券商直投', '战投/CVC'],
  },
  投资阶段: {
    label: '投资阶段',
    width: '25%',
    type: 'multSelect',
    options: ['天使轮及之前', 'PreA', 'A', 'B', 'C', 'Growth/PE', 'Pre-IPO', '一级半定增', 'Buyout'],
  },
  特殊能力: {
    label: '特殊能力',
    width: '25%',
    type: 'multSelect',
    options: ['募资资源', '投后管理', '有退出经验', 'sourcing项目'],
  },
  公司类型: {
    label: '公司类型',
    width: '25%',
    type: 'multSelect',
    options: [
      '国企/央企',
      '民营企业',
      '合资公司',
      '跨国企业',
      '上市公司',
      '非上市公司',
      '集团/控股公司',
      '海外工作',
      '自主创业',
    ],
  },
  会计准则及证书: {
    label: '会计准则及证书',
    width: '25%',
    type: 'multSelect',
    labelWidth: '100px',
    options: [
      '中国会计准则',
      '国际会计准则（IFRS）',
      '美国会计准则（US GAAP）',
      '注册会计师',
      '管理会计师',
      '董秘资格证',
      '证券从业资格',
      '基金从业资格',
      '无',
    ],
  },
  项目及其他技能: {
    label: '项目及其他技能',
    width: '25%',
    type: 'multSelect',
    labelWidth: '100px',
    options: ['抗体', '小核酸', '细胞治疗', '基因治疗', '疫苗'],
  },
  金融业务方向: {
    label: '金融业务方向',
    width: '25%',
    labelWidth: '100px',
    type: 'multSelect',
    options: ['资管', '投行', '专户', '公募', '自营', '财富管理', '并购'],
  },
  技术方向: {
    label: '技术方向',
    width: '25%',
    type: 'multSelect',
    options: ['资管', '投行', '专户', '公募', '自营', '财富管理', '并购'],
  },
  治疗领域: {
    label: '治疗领域',
    width: '25%',
    type: 'multSelect',
    options: [
      '肝病',
      'CNS',
      '眼科',
      '罕见病',
      '抗感染',
      '心血管',
      '内分泌/糖尿病',
      '肾病',
      '妇科/生殖',
      '儿科',
      '消化',
      '呼吸',
      '骨科',
    ],
  },
  技术赛道: {
    label: '技术赛道',
    width: '25%',
    type: 'multSelect',
    options: ['小分子', '抗体', 'ADC', '小核酸', 'mRNA', '细胞治疗', '基因治疗', '溶瘤病毒'],
  },
  实体瘤: {
    label: '实体瘤',
    width: '25%',
    type: 'multSelect',
    options: [
      '肺癌',
      '头颈癌',
      '黑色素瘤',
      '泌尿肿瘤',
      '肾癌',
      '妇科肿瘤',
      '乳腺癌',
      '卵巢癌',
      '消化道肿瘤',
      '胃癌',
      '肠癌',
      '肝癌',
      '胰腺癌',
    ],
  },
  医药程序员: {
    label: '医药程序员',
    width: '25%',
    type: 'multSelect',
    labelWidth: '100px',
    options: ['SASS程序员', '数据库程序员', '统计程序员'],
  },
}
// 搜索特殊字段 医疗-：医疗科室 工业-：业务方向 芯片：是否量产、是否流片
const cateFieldMap = {
  'IBD-投行': ['承揽-承做', '意向平台'],
  'FI-债券开发执行': ['承揽-承做'],
  'FOF-FOF': ['公开业绩', '投资标的', '投资年限', '规模'],
  'FII-固收投资': ['公开业绩', '投资年限', '规模'],
  'FIR-固收研究': ['投资年限', '规模'],
  'QUANT-量化投资': ['公开业绩', '投资年限', '规模'],
  'QUANT-量化研究': ['投资年限', '规模'],
  'RI-研究': ['转换诉求'],
  公募REITs: ['REITs任职情况'],
  'PEVC-股权投资': ['特殊能力', '平台性质', '投资阶段'],
  'FIN-财务': ['公司类型', '上市经验', '业务类型', '会计准则及证书', '项目及其他技能', '金融业务方向'],
  'CFO-财务总监': ['公司类型', '上市经验', '业务类型', '会计准则及证书', '项目及其他技能'],
  '医药-医学事务MED': ['治疗领域', '实体瘤'],
  '医药-注册申报RA': ['技术方向'],
  '医药-上市前医学': ['技术方向', '治疗领域', '实体瘤'],
  '医药-生物统计': ['医药程序员'],
  '医药-PV': ['治疗领域'],
  董事会高管: ['公司类型'],
  'CEO-首席执行官': ['公司类型'],
  'COO-首席运营官': ['公司类型'],
  'CTO-首席技术官': ['公司类型'],
  'CHO-首席人力官': ['公司类型'],
  'CSO-首席策略官': ['公司类型'],
  'CSO-首席科学官': ['公司类型'],
  'CIO-首席信息官': ['公司类型'],
  'CIO-首席投资官': ['公司类型'],
  'CMO-首席市场官': ['公司类型'],
  'Sales VP-高级副总裁': ['公司类型'],
  '医药-Biology': ['治疗领域', '技术赛道'],
}
export { searchFieldsOnekey, cateFieldOnekey, cateFieldMap }
